import {onDomReady} from "../../components/dynamic/observer";
import {Swiper, Pagination} from 'swiper';
import '../../../node_modules/swiper/swiper.scss';

function init() {
    const productSliderContainer = document.querySelector('[data-product-base-slider-container]');
    if (!productSliderContainer) {
        return;
    }

    const productSliderPrimary = document.querySelector('[data-product-base-slider-primary]');
    const productSliderSecondary = document.querySelector('[data-product-base-slider-secondary]');
    if (!productSliderPrimary) {
        return;
    }

    const productSliderPagination  = document.querySelector('[data-product-base-slider-pagination]');
    let primarySlider, secondarySlider;

    if (productSliderSecondary)  {
        secondarySlider = new Swiper(productSliderSecondary, {
            preventInteractionOnTransition: true,
            slidesPerView: "auto",
            clickable: true,
            freeMode: true,
            spaceBetween: 7,
            direction: "vertical",
        });
    }

    primarySlider = new Swiper(productSliderPrimary, {
        modules: [Pagination],
        preventInteractionOnTransition: true,
        pagination: {
            el: productSliderPagination,
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="product-base-top-slider__pagination-bullet ' + className + '"></span>';
            },
        },
    });

    if (primarySlider && secondarySlider) {
        if (window.innerWidth < 1200) {
            return;
        }
        primarySlider.on('activeIndexChange', () => {
            removeActiveFromSlides();

            secondarySlider.slideTo(primarySlider.activeIndex);
            secondarySlider.slides[primarySlider.activeIndex].classList.add('_active');
        });

        secondarySlider.slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                removeActiveFromSlides();

                primarySlider.slideTo(index);
                slide.classList.add('_active');
            });
        });
    }

    const removeActiveFromSlides = () => {
        secondarySlider.slides.map((slide) => slide.classList.remove('_active'));
    }
}

onDomReady(init);